import { apiCallPost } from "../api"
import { apiPaths } from "../config/apiPaths";

export const getCategoriesApi = async (locale, companyId, authHeaders) => {
    const inputData = {
        locale: locale,
    }
    try {
        const res = await apiCallPost(apiPaths.getCategories, inputData,authHeaders);
        if (res) {
            let listData = res ?? {};
            return { data: listData, status: true }
        }
        return { data: [], status: false, errMsg: 'Some Error Occurred' };
    } catch (err) {
        return { status: false, errMsg: err.message }
    }
}